import { GameEngine } from '../GameEngine';

interface GameUIProps {
  engine: GameEngine | undefined;
}

export function GameUI({ engine }: GameUIProps) {
  return (
    <div
      style={{
        position: 'fixed',
        top: 20,
        left: 20,
        display: 'flex',
        flexDirection: 'column',
        gap: '15px',
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        padding: '15px',
        borderRadius: '8px',
        zIndex: 1000,
        color: 'white',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
        }}
      >
        <span style={{ fontSize: '24px', color: '#44ff44' }}>
          ❤️ Togetherness
        </span>
        <div
          style={{
            width: '300px',
            height: '30px',
            border: '3px solid #44ff44',
            borderRadius: '15px',
            background: '#113311',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              position: 'absolute',
              left: 0,
              top: 0,
              height: '100%',
              width: `${
                100 -
                ((engine?.getOffScreenTimer() || 0) /
                  (engine?.getMaxOffScreenTime() || 3600)) *
                  100
              }%`,
              background: 'linear-gradient(90deg, #44ff44, #88ff88)',
              transition: 'width 0.2s ease-out',
            }}
          />
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
        }}
      >
        <span style={{ fontSize: '24px', color: '#ff4444' }}>⛽ Gas</span>
        <div
          style={{
            width: '300px',
            height: '30px',
            border: '3px solid #ff4444',
            borderRadius: '15px',
            background: '#331111',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              position: 'absolute',
              left: 0,
              top: 0,
              height: '100%',
              width: `${engine?.getRedGas() || 0}%`,
              background: 'linear-gradient(90deg, #ff4444, #ff8888)',
              transition: 'width 0.2s ease-out',
            }}
          />
        </div>
      </div>
    </div>
  );
}
